import { render, staticRenderFns } from "./QuickDesign.vue?vue&type=template&id=5cb21658&scoped=true"
import script from "./QuickDesign.vue?vue&type=script&lang=js"
export * from "./QuickDesign.vue?vue&type=script&lang=js"
import style0 from "./QuickDesign.vue?vue&type=style&index=0&id=5cb21658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb21658",
  null
  
)

export default component.exports